import { ReactNode } from "react";
import { Box } from "@mui/material";
import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()(() => ({
  body: {
    flex: 1,
    overflow: "auto",
    minHeight: "100vh",
  },
}));

export default function DashboardBody(props: { children: ReactNode }) {
  const { classes } = useStyles();

  return <Box className={classes.body}>{props.children}</Box>;
}